import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { boolParse, dateParser } from "../../../Common/Review/ReviewParser";
export interface CappedAndFlexiTableColumnsProps {
    Title: string;
    Key?: string;
    type?: ColumnType;
}
export interface CappedAndFlexiTableProps {
    tableTitle: string;
    data?: any[];
    columnsType?: CappedAndFlexiTableColumnsProps[];
}

export const enum ColumnType {
    PlainText = 0,
    Money = 1,
    Percentage = 2,
    DateTime = 3,
    bool = 4,
}
export const CappedAndFlexiTableReview = (props: CappedAndFlexiTableProps): JSX.Element => {
    const getCellData = (type: ColumnType, value) => {
        switch (type) {
            case ColumnType.PlainText:
                return <td>{value}</td>;
            case ColumnType.Money:
                return <td>{MoneyDisplayHelper.FromatMoneyDisplay(value, CurrencyCode.GBP, true, 2)}</td>;
            case ColumnType.Percentage:
                return <td>{value + "%"}</td>;
            case ColumnType.bool:
                return <td>{boolParse(value)}</td>;
            case ColumnType.DateTime:
                return <td>{dateParser(value)}</td>;
            default:
                return <td>{value} </td>;
        }
    };

    return (
        <>
            <h3 className="mb-11">{props.tableTitle}</h3>
            <table>
                <tbody>
                    {props.columnsType.map((row, index) => {
                        return (
                            <tr key={row.Title + index}>
                                <td className="text-left"> {<h4 className="mb-11">{row.Title}</h4>}</td>
                                {props.data.map((item) => {
                                    return getCellData(row.type, item[row.Key]);
                                })}
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot></tfoot>
            </table>
        </>
    );
};
